import { useRef, useEffect } from 'react'

// components
import { InputText } from 'primereact/inputtext'

import {
  sanitizeAndTruncateString,
  isForbiddenChar
} from '@aytm/app/stats/page/question-views/hm/components/controls/cluster-form/lib/utils'

export const TitleInput = ({ value, onChange, className, placeholder, disabled }) => {
  const timerRef = useRef(null)

  useEffect(() => () => clearTimeout(timerRef.current), [])

  const handleChange = event => {
    onChange(sanitizeAndTruncateString(event.target.value))
  }

  const handleKeyDown = event => {
    if (event.keyCode === 13) event.preventDefault()
    if (isForbiddenChar(event.key)) event.preventDefault()
  }

  const handlePaste = event => {
    event.preventDefault()

    const pastedText =
      // @ts-ignore
      (event.clipboardData || window.clipboardData)?.getData('Text') || event.clipboardData?.getData('text/plain') || ''

    const el = event.currentTarget
    const start = el.selectionStart
    const end = el.selectionEnd

    const newText = sanitizeAndTruncateString(`${el.value.slice(0, start)}${pastedText}${el.value.slice(end)}`)
    onChange(newText)

    // Restore cursor position after paste
    const newCursorPos = start + pastedText.length
    clearTimeout(timerRef.current)
    timerRef.current = setTimeout(() => {
      el.setSelectionRange(newCursorPos, newCursorPos)
      el.blur()
      el.focus()
    }, 100)
  }

  return (
    <InputText
      type="text"
      value={value}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      onPaste={handlePaste}
      className={className}
      placeholder={placeholder}
      disabled={disabled}
    />
  )
}
